import {createSelector} from 'reselect';

import * as state from '../../App/selectors';

export const selectActivePromo = createSelector([state.getActivePromo], promo => promo);
